/**
 * Copyright (c) 2025-2026 Four Hour Window LLC
 * All rights reserved.
 * 
 * This source code is proprietary and confidential.
 * Unauthorized copying, distribution, or use is strictly prohibited.
 */

import React from 'react';
import PayoutForm from '../PayoutForm.tsx';
import LoadingSpinner from '../LoadingSpinner.tsx';
interface PayoutModalProps {
  isOpen: boolean;
  isSaving: boolean;
  selectedOrders: any[];
  totalAmount: number;
  collectionName: string;
  isAdmin: boolean;
  onClose: () => void;
  onSubmit: (data: any) => void;
}

const PayoutModal: React.FC<PayoutModalProps> = ({
  isOpen,
  isSaving,
  selectedOrders,
  totalAmount,
  collectionName,
  isAdmin,
  onClose,
  onSubmit,
}) => {
  console.log('📦 PayoutModal received selectedOrders:', selectedOrders);
  console.log('📦 First order in modal:', selectedOrders[0]);
  
  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000
    }}>
      <button
        onClick={onClose}
        disabled={isSaving}
        style={{
          position: 'fixed',
          top: '0',
          right: '0',
          padding:'10px 20px',
          background: 'none',
          border: 'none',
          fontSize: '24px',
          cursor: isSaving ? 'not-allowed' : 'pointer',
          color:'#000000',
          opacity: isSaving ? 0.5 : 1
        }}
      >
        ×
      </button>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '8px',
        padding: '20px',
        maxWidth: '600px',
        maxHeight: '80vh',
        overflow: 'auto',
        position: 'relative'
      }}>
        {/* Saving Overlay */}
        {isSaving && (
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 10,
            borderRadius: '8px'
          }}>

           <LoadingSpinner size={40} />

            <div style={{
              marginTop: '20px',
              fontSize: '18px',
              fontWeight: 'bold',
              color: '#28a745'
            }}>
              Saving...
            </div>
            <div style={{
              marginTop: '8px',
              fontSize: '14px',
              color: '#666'
            }}>
              Creating payout record
            </div>
          </div>
        )}
        
        <button
          onClick={onClose}
          disabled={isSaving}
          style={{
            position: 'absolute',
            top: '10px',
            right: '10px',
            background: 'none',
            border: 'none',
            fontSize: '24px',
            cursor: isSaving ? 'not-allowed' : 'pointer',
            color: '#666',
            opacity: isSaving ? 0.5 : 1
          }}
        >
          ×
        </button>
        
    <PayoutForm
  orderId="batch"
  orderNumber={selectedOrders
    .map((order: any) => String(order.orderNumber))  // ← Just convert to string, no #
    .join(', ')
  }
  payoutAmount={totalAmount}
  isAdmin={isAdmin}
  onSubmit={onSubmit}
    checkedOrders={selectedOrders.map((order: any) => {
    // Clean the order number - remove # if present and ensure it's a string
    let cleanOrderNumber = String(order.orderNumber);
    
    console.log('🔍 Before cleaning:', cleanOrderNumber, 'Type:', typeof cleanOrderNumber);
    
    // Remove # if it exists
    if (cleanOrderNumber.startsWith('#')) {
        cleanOrderNumber = cleanOrderNumber.substring(1);
    }
    
    console.log('🔍 After cleaning:', cleanOrderNumber, 'Type:', typeof cleanOrderNumber);
    
    return {
        id: String(order.orderId),
        number: cleanOrderNumber,  // Clean string without #
        amount: order.calculatedAmount || 0
    };
    })}
  collectionName={collectionName}
/>
      </div>
    </div>
  );
};

export default PayoutModal;